import React, { useEffect, useState } from "react";
import { Select, Spinner } from "@chakra-ui/react";
import { FormGroup } from "./FormGroup";
import { useField } from "../../../hooks/FormGeneratorHooks";
import { HiCheckCircle } from "react-icons/hi";
import { MdErrorOutline } from "react-icons/md";
import { useAtom } from "jotai";
import { userAtom } from "../../../state/auth";

export const FieldSelect = (props) => {
  const {
    errorMessage,
    id,
    isValid,
    isSubmitted,
    resetKey,
    setValue,
    value,
    otherProps,
  } = useField(props);
  const { required, name } = props;
  const {
    children,
    label,
    options = [],
    placeholder,
    helper,
    ...rest
  } = otherProps;

  const [isTouched, setIsTouched] = useState(false);
  const [isValidation, setIsValidation] = useState(false);
  const showError = !isValid && (isTouched || isSubmitted);
  const [user, setUser] = useAtom(userAtom);
  useEffect(() => {
    setIsTouched(false);
  }, [resetKey]);
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const formGroupProps = {
    errorMessage,
    helper,
    id,
    isRequired: !!required,
    label,
    showError,
    name,
    ...rest,
  };

  if (name === "startFromSurveyId") {
  }
  return (
    <FormGroup {...formGroupProps}>
      <Select
        borderWidth={props.readOnly ? 2 : 1}
        multiple={props.Multiple ? true : false}
        id={id}
        fontSize="14px"
        _invalid={{ borderColor: "Red" }}
        className="border border-gray-400 focus:border-blue-500 focus:shadow-sm w-full "
        value={value || ""}
        onBlur={(e) => {
          setIsTouched(true);
          setIsValidation(false);
          if (props?.onSumbit)
            props.onSumbit({
              fieldName: name,
              value: e.target.value,
              isValid: isValid,
            });
        }}
        aria-invalid={showError}
        aria-describedby={!isValid ? `${id}-error` : undefined}
        placeholder={placeholder ? placeholder : " "}
        onChange={(e) => {
          setValue(e.target.value);
          setIsValidation(true);
        }}
        disabled={props.readOnly ? props.readOnly : false}
        // fontSize="14px"
        style={{ minHeight: "45px" }}
      >
        {(options || []).map((item) => (
          <option
            key={item.value}
            value={item.value}
            disabled={item.disabled ? true : false}
            style={{ fontSize: "14px" }}
          >
            {item.label || item.value}
          </option>
        ))}
      </Select>
      {user?.type !== "cro" && user?.type !== "arc" && (
        <div className="absolute -left-8 top-1/2">
          {" "}
          {isValidation && (
            <p>
              <Spinner size="sm" flex="none" color="blue.200" />
            </p>
          )}
          <p>
            {" "}
            {isValid && !isValidation && (
              <HiCheckCircle color="#67d428" width={20} height={20} />
            )}
            {!isValid && !isValidation && (
              <MdErrorOutline color="#ff0000" width={20} height={20} />
            )}
          </p>
        </div>
      )}

      {children}
    </FormGroup>
  );
};
